/*====================================================================================================
	作成日:2022/08/30		最終更新日:2022/08/30
	作成者:GFTD天神-徳渕	最終更新者:GFTD天神-徳渕
====================================================================================================*/

import React, { createContext } from "react";

// registerのコンテキスト
export const RegisterContext = createContext();